/**
 * 省市区数据
 *
 * @description 国家-省市区四级联动数据，供前端和App使用
 * 包含国家、省份、城市、区县四级
 */

export interface AreaData {
  value: string;
  label: string;
  children?: AreaData[];
}

/**
 * 中国省市区数据（省份为第一级）
 * 结构：省份 -> 城市 -> 区县
 */
export const AREA_PROVINCE_DATA: AreaData[] = [
  {
    value: '北京',
    label: '北京',
    children: [
      {
        value: '北京市',
        label: '北京市',
        children: [
          { value: '东城区', label: '东城区' },
          { value: '西城区', label: '西城区' },
          { value: '朝阳区', label: '朝阳区' },
          { value: '丰台区', label: '丰台区' },
          { value: '石景山区', label: '石景山区' },
          { value: '海淀区', label: '海淀区' },
          { value: '门头沟区', label: '门头沟区' },
          { value: '房山区', label: '房山区' },
          { value: '通州区', label: '通州区' },
          { value: '顺义区', label: '顺义区' },
          { value: '昌平区', label: '昌平区' },
          { value: '大兴区', label: '大兴区' },
          { value: '怀柔区', label: '怀柔区' },
          { value: '平谷区', label: '平谷区' },
          { value: '密云区', label: '密云区' },
          { value: '延庆区', label: '延庆区' },
        ],
      },
    ],
  },
  {
    value: '上海',
    label: '上海',
    children: [
      {
        value: '上海市',
        label: '上海市',
        children: [
          { value: '黄浦区', label: '黄浦区' },
          { value: '徐汇区', label: '徐汇区' },
          { value: '长宁区', label: '长宁区' },
          { value: '静安区', label: '静安区' },
          { value: '普陀区', label: '普陀区' },
          { value: '虹口区', label: '虹口区' },
          { value: '杨浦区', label: '杨浦区' },
          { value: '闵行区', label: '闵行区' },
          { value: '宝山区', label: '宝山区' },
          { value: '嘉定区', label: '嘉定区' },
          { value: '浦东新区', label: '浦东新区' },
          { value: '金山区', label: '金山区' },
          { value: '松江区', label: '松江区' },
          { value: '青浦区', label: '青浦区' },
          { value: '奉贤区', label: '奉贤区' },
          { value: '崇明区', label: '崇明区' },
        ],
      },
    ],
  },
  {
    value: '广东',
    label: '广东',
    children: [
      {
        value: '广州市',
        label: '广州市',
        children: [
          { value: '荔湾区', label: '荔湾区' },
          { value: '越秀区', label: '越秀区' },
          { value: '海珠区', label: '海珠区' },
          { value: '天河区', label: '天河区' },
          { value: '白云区', label: '白云区' },
          { value: '黄埔区', label: '黄埔区' },
          { value: '番禺区', label: '番禺区' },
          { value: '花都区', label: '花都区' },
          { value: '南沙区', label: '南沙区' },
          { value: '从化区', label: '从化区' },
          { value: '增城区', label: '增城区' },
        ],
      },
      {
        value: '深圳市',
        label: '深圳市',
        children: [
          { value: '罗湖区', label: '罗湖区' },
          { value: '福田区', label: '福田区' },
          { value: '南山区', label: '南山区' },
          { value: '宝安区', label: '宝安区' },
          { value: '龙岗区', label: '龙岗区' },
          { value: '盐田区', label: '盐田区' },
          { value: '龙华区', label: '龙华区' },
          { value: '坪山区', label: '坪山区' },
          { value: '光明区', label: '光明区' },
        ],
      },
      {
        value: '东莞市',
        label: '东莞市',
        children: [
          { value: '莞城街道', label: '莞城街道' },
          { value: '南城街道', label: '南城街道' },
          { value: '东城街道', label: '东城街道' },
          { value: '万江街道', label: '万江街道' },
          { value: '石龙镇', label: '石龙镇' },
          { value: '虎门镇', label: '虎门镇' },
          { value: '长安镇', label: '长安镇' },
        ],
      },
      {
        value: '佛山市',
        label: '佛山市',
        children: [
          { value: '禅城区', label: '禅城区' },
          { value: '南海区', label: '南海区' },
          { value: '顺德区', label: '顺德区' },
          { value: '三水区', label: '三水区' },
          { value: '高明区', label: '高明区' },
        ],
      },
      { value: '珠海市', label: '珠海市' },
      { value: '中山市', label: '中山市' },
      { value: '惠州市', label: '惠州市' },
      { value: '江门市', label: '江门市' },
    ],
  },
  {
    value: '江苏',
    label: '江苏',
    children: [
      {
        value: '南京市',
        label: '南京市',
        children: [
          { value: '玄武区', label: '玄武区' },
          { value: '秦淮区', label: '秦淮区' },
          { value: '建邺区', label: '建邺区' },
          { value: '鼓楼区', label: '鼓楼区' },
          { value: '浦口区', label: '浦口区' },
          { value: '栖霞区', label: '栖霞区' },
          { value: '雨花台区', label: '雨花台区' },
          { value: '江宁区', label: '江宁区' },
          { value: '六合区', label: '六合区' },
          { value: '溧水区', label: '溧水区' },
          { value: '高淳区', label: '高淳区' },
        ],
      },
      {
        value: '苏州市',
        label: '苏州市',
        children: [
          { value: '姑苏区', label: '姑苏区' },
          { value: '虎丘区', label: '虎丘区' },
          { value: '吴中区', label: '吴中区' },
          { value: '相城区', label: '相城区' },
          { value: '吴江区', label: '吴江区' },
          { value: '昆山市', label: '昆山市' },
          { value: '太仓市', label: '太仓市' },
          { value: '常熟市', label: '常熟市' },
          { value: '张家港市', label: '张家港市' },
        ],
      },
      { value: '无锡市', label: '无锡市' },
      { value: '常州市', label: '常州市' },
      { value: '南通市', label: '南通市' },
      { value: '扬州市', label: '扬州市' },
    ],
  },
  {
    value: '浙江',
    label: '浙江',
    children: [
      {
        value: '杭州市',
        label: '杭州市',
        children: [
          { value: '上城区', label: '上城区' },
          { value: '拱墅区', label: '拱墅区' },
          { value: '西湖区', label: '西湖区' },
          { value: '滨江区', label: '滨江区' },
          { value: '萧山区', label: '萧山区' },
          { value: '余杭区', label: '余杭区' },
          { value: '临平区', label: '临平区' },
          { value: '钱塘区', label: '钱塘区' },
          { value: '富阳区', label: '富阳区' },
          { value: '临安区', label: '临安区' },
        ],
      },
      {
        value: '宁波市',
        label: '宁波市',
        children: [
          { value: '海曙区', label: '海曙区' },
          { value: '江北区', label: '江北区' },
          { value: '北仑区', label: '北仑区' },
          { value: '镇海区', label: '镇海区' },
          { value: '鄞州区', label: '鄞州区' },
          { value: '奉化区', label: '奉化区' },
          { value: '余姚市', label: '余姚市' },
          { value: '慈溪市', label: '慈溪市' },
        ],
      },
      { value: '温州市', label: '温州市' },
      { value: '嘉兴市', label: '嘉兴市' },
      { value: '湖州市', label: '湖州市' },
      { value: '绍兴市', label: '绍兴市' },
      { value: '金华市', label: '金华市' },
      { value: '台州市', label: '台州市' },
    ],
  },
  {
    value: '山东',
    label: '山东',
    children: [
      { value: '济南市', label: '济南市' },
      { value: '青岛市', label: '青岛市' },
      { value: '烟台市', label: '烟台市' },
      { value: '潍坊市', label: '潍坊市' },
      { value: '济宁市', label: '济宁市' },
      { value: '淄博市', label: '淄博市' },
      { value: '临沂市', label: '临沂市' },
      { value: '泰安市', label: '泰安市' },
    ],
  },
  {
    value: '河北',
    label: '河北',
    children: [
      { value: '石家庄市', label: '石家庄市' },
      { value: '唐山市', label: '唐山市' },
      { value: '秦皇岛市', label: '秦皇岛市' },
      { value: '邯郸市', label: '邯郸市' },
      { value: '邢台市', label: '邢台市' },
      { value: '保定市', label: '保定市' },
      { value: '张家口市', label: '张家口市' },
      { value: '承德市', label: '承德市' },
      { value: '沧州市', label: '沧州市' },
      { value: '廊坊市', label: '廊坊市' },
      { value: '衡水市', label: '衡水市' },
    ],
  },
  {
    value: '河南',
    label: '河南',
    children: [
      { value: '郑州市', label: '郑州市' },
      { value: '开封市', label: '开封市' },
      { value: '洛阳市', label: '洛阳市' },
      { value: '平顶山市', label: '平顶山市' },
      { value: '安阳市', label: '安阳市' },
      { value: '新乡市', label: '新乡市' },
      { value: '焦作市', label: '焦作市' },
    ],
  },
  {
    value: '湖北',
    label: '湖北',
    children: [
      { value: '武汉市', label: '武汉市' },
      { value: '黄石市', label: '黄石市' },
      { value: '十堰市', label: '十堰市' },
      { value: '宜昌市', label: '宜昌市' },
      { value: '襄阳市', label: '襄阳市' },
      { value: '荆州市', label: '荆州市' },
    ],
  },
  {
    value: '湖南',
    label: '湖南',
    children: [
      { value: '长沙市', label: '长沙市' },
      { value: '株洲市', label: '株洲市' },
      { value: '湘潭市', label: '湘潭市' },
      { value: '衡阳市', label: '衡阳市' },
      { value: '岳阳市', label: '岳阳市' },
      { value: '常德市', label: '常德市' },
    ],
  },
  {
    value: '四川',
    label: '四川',
    children: [
      { value: '成都市', label: '成都市' },
      { value: '绵阳市', label: '绵阳市' },
      { value: '德阳市', label: '德阳市' },
      { value: '南充市', label: '南充市' },
      { value: '宜宾市', label: '宜宾市' },
      { value: '泸州市', label: '泸州市' },
    ],
  },
  {
    value: '重庆',
    label: '重庆',
    children: [
      {
        value: '重庆市',
        label: '重庆市',
        children: [
          { value: '渝中区', label: '渝中区' },
          { value: '江北区', label: '江北区' },
          { value: '南岸区', label: '南岸区' },
          { value: '九龙坡区', label: '九龙坡区' },
          { value: '沙坪坝区', label: '沙坪坝区' },
          { value: '大渡口区', label: '大渡口区' },
          { value: '渝北区', label: '渝北区' },
          { value: '巴南区', label: '巴南区' },
        ],
      },
    ],
  },
  {
    value: '天津',
    label: '天津',
    children: [
      {
        value: '天津市',
        label: '天津市',
        children: [
          { value: '和平区', label: '和平区' },
          { value: '河东区', label: '河东区' },
          { value: '河西区', label: '河西区' },
          { value: '南开区', label: '南开区' },
          { value: '河北区', label: '河北区' },
          { value: '红桥区', label: '红桥区' },
          { value: '滨海新区', label: '滨海新区' },
          { value: '东丽区', label: '东丽区' },
          { value: '西青区', label: '西青区' },
          { value: '津南区', label: '津南区' },
          { value: '北辰区', label: '北辰区' },
          { value: '武清区', label: '武清区' },
          { value: '宝坻区', label: '宝坻区' },
        ],
      },
    ],
  },
  {
    value: '福建',
    label: '福建',
    children: [
      { value: '福州市', label: '福州市' },
      { value: '厦门市', label: '厦门市' },
      { value: '泉州市', label: '泉州市' },
      { value: '漳州市', label: '漳州市' },
      { value: '莆田市', label: '莆田市' },
      { value: '龙岩市', label: '龙岩市' },
    ],
  },
  {
    value: '安徽',
    label: '安徽',
    children: [
      { value: '合肥市', label: '合肥市' },
      { value: '芜湖市', label: '芜湖市' },
      { value: '蚌埠市', label: '蚌埠市' },
      { value: '淮南市', label: '淮南市' },
      { value: '马鞍山市', label: '马鞍山市' },
      { value: '安庆市', label: '安庆市' },
    ],
  },
  {
    value: '江西',
    label: '江西',
    children: [
      { value: '南昌市', label: '南昌市' },
      { value: '九江市', label: '九江市' },
      { value: '赣州市', label: '赣州市' },
      { value: '吉安市', label: '吉安市' },
      { value: '宜春市', label: '宜春市' },
      { value: '上饶市', label: '上饶市' },
    ],
  },
];

/**
 * 国家列表数据（目前主要支持中国）
 * 结构：国家 -> 省份 -> 城市 -> 区县
 */
export const COUNTRY_DATA: AreaData[] = [
  {
    value: '中国',
    label: '中国',
    children: AREA_PROVINCE_DATA,
  },
  // 可以后续扩展其他国家
  // {
  //   value: '美国',
  //   label: '美国',
  //   children: [...]
  // },
];

/**
 * 兼容旧版本：AREA_DATA 仍然可用
 * @deprecated 推荐使用 COUNTRY_DATA（包含国家层级）或 AREA_PROVINCE_DATA（仅省份层级）
 */
export const AREA_DATA = AREA_PROVINCE_DATA;

